import { CheckOutlined, CloseOutlined, DeleteOutlined, DownloadOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Checkbox, Col, Dropdown, Modal, Row, Space, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useMemo, useState } from "react";
import { exportExcelWhitelist, exportFileHistory } from "../services/whiteListApi";


function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

const HistoryFilesTable = ({
  isLoading = false,
  // dataSource = [],
  pagination = {},
  setPagination = () => { },
  isModalOpen = false,
  setModalOpen = () => { },
  onRowClick = () => { },
  onChange = () => { },
  onCancel = () => { },
  getFileHistoryFn = () => { },

}) => {
  const { t, i18n } = useTranslation();
  const [dataSource, setDataSource] = useState([])
  console.log("paginationpaginationpaginationpagination", pagination);

  // let dataSource = {}
  // function setDataSource(params) {
  //     dataSource = params
  // }
  // getFileHistoryFn(setDataSource)

  useMemo(() => {
    if (isModalOpen) {
      getFileHistoryFn(setDataSource)
    }
  }, [isModalOpen])

  const columns = [
    // {
    //   title: <div className="text-table">{t('req_id.req_id')}</div>,
    //   dataIndex: "sequence",
    //   key: "sequence",
    // },
    {
      title: <div className="text-table">{t('fileName')}</div>,
      dataIndex: "attachFileFs",
      key: "attachFileFs",
      render: (text, record) => {
        return text?.fileName
      }
    },
    {
      title: <div className="text-table">{t('totalRecord')}</div>,
      dataIndex: "totalRecord",
      key: "totalRecord",
      align: "center",
      // render: (text, record) => {
      //   // console.log(record);
      //   return i18n.language === 'en' ? record?.movementType?.nameEn : record?.movementType?.name
      // }
    },
    {
      title: <div className="text-table">{t('name-surname-edit')}</div>,
      dataIndex: "createBy",
      key: "createBy",
      render: (text, record) => {
        return i18n.language === 'en' ? text?.nameAndSurnameEn : text?.nameAndSurname
      }
    },

    // {
    //   title: <div className="text-table">{t('warning_letter.label.effective_date')}</div>,
    //   dataIndex: "startTime",
    //   key: "startTime",
    //   render: (_, record) => {
    //     return <div>{formatDate({ dateString: record?.startTime, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</div>
    //   }
    // },
    {
      title: <div className="text-table">{t('uploadDate')}</div>,
      dataIndex: "createDate",
      key: "createDate",
      align: "center",
      render: (_, record) => (dayjs(_).format("DD/MM/BBBB hh:mm:ss"))
    },
    {
      title: <div className="text-table">{t('common.download')}</div>,
      key: "attachFileFs",
      dataIndex: "attachFileFs",
      align: "center",
      render: (_, record) => (
        <DownloadOutlined onClick={() => {
          exportFileHistory({ requestId: _.fileId }).then(res => {
            const url = window.URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', _.fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
        }} style={{ fontSize: "18px", color: "gray" }} />
      ),
    },


  ];

  return (
    <>
      <Modal
        destroyOnClose
        title={t("salary.label.history")}
        open={isModalOpen}
        onCancel={() => {
          // setModalOpen(false);
          onCancel()
        }}
        width="1000px"
        footer={null}
      >
        <TableAntd
          loading={isLoading}
          dataSource={dataSource}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              t("paginate.description")
                .replace("{min}", range[0])
                .replace("{max}", range[1])
                .replace("{total}", total),
          }}
          // dataSource={dataSource}
          rowKey={(record) => record.id}
          columns={columns}
          onChange={(pagination, filter, sorter) => {
            console.log("pagination", pagination, sorter);
            const modifiedSorter = Array.isArray(sorter)
              ? [...sorter]
              : [sorter];
            console.log("modifiedSorter", modifiedSorter);
            getFileHistoryFn(setDataSource,
              {
                filter: pagination?.filter,
                page: pagination?.current - 1,
                size: pagination?.pageSize,
                pageSize: pagination?.pageSize,
                sortBy: modifiedSorter
                  .filter((s) => s.order !== undefined)
                  .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                  })),
              })
          }}
        />
      </Modal>
    </>

  );
};

export default HistoryFilesTable;
